// extracted by mini-css-extract-plugin
export default {"scanner":"ScanBarcode_scanner__Jy5pM"};